import { FC } from 'react';
import { TbCurrencyDollar, TbCurrencyDollarOff } from 'react-icons/tb';
import IconToggleDropdown, { IconToggleDropdownProps } from 'components/IconToggleDropdown';

interface BillableToggleProps extends Omit<IconToggleDropdownProps, 'trueOption' | 'falseOption' | 'menuTitle'> {
  size?: number;
  resource?: string;
}

const BillableToggle: FC<BillableToggleProps> = ({ size = 20, resource = 'item', ...props }) => (
  <IconToggleDropdown
    {...props}
    trueOption={{
      label: 'Billable',
      icon: <TbCurrencyDollar size={size} color="#35a220" />,
      tooltip: 'Billable',
      confirmTitle: `Do you want to mark this ${resource} as billable?`,
    }}
    falseOption={{
      label: 'Non-billable',
      icon: <TbCurrencyDollarOff size={size} color="red" />,
      tooltip: 'Non-billable',
      confirmTitle: `Do you want to mark this ${resource} as non-billable?`,
    }}
  />
);

export default BillableToggle;
